import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    height: 100vh;
    max-width: 400px;
    margin: 0 auto;
    padding: 20px;
    @media screen and (max-width: 769px) {
        max-width: 700px;
        margin: 0;
    }
`;

export const Banner = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 40px;
`;

export const TextBlock = styled.div`
    display: flex;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #040222;
    margin-top: 12px;
`;

export const OrderedList = styled.ol``;
export const OrderListItem = styled.li`
    font-weight: 500;
    margin-top: 10px;
`;

export const Text = styled.div`
    display: flex;
    justify-content: center;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    text-align: center;
    color: #040222;
    margin: 0 0 12px 0;
`;

export const SubTextBlock = styled.div`
    display: flex;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #5b5675;
    margin-top: 10px;
`;

export const LightSubTextBlock = styled.div`
    display: flex;
    flex-direction: column;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #5b5675;
    margin-top: 10px;
    padding: 20px;
    border-radius: 4px;
    background-color: #ffebfa;
`;

export const SubText = styled.div`
    display: flex;
    justify-content: center;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #5b5675;
    margin-top: 10px;
`;

export const Description = styled.div`
    display: flex;
    justify-content: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    color: #5b5675;
    margin-top: 16px;
    text-align: center;
`;
export const GoHomeButtonWrapper = styled.div`
    display: flex;
    width: 100%;
    margin-top: 32px;
`;
